/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

import type { EntityIdRef } from './entity-id-ref';
import type { DragAndDropMappingFromLiveClient } from './drag-and-drop-mapping-from-live-client';

export interface DragAndDropSubmittedAnswerFromLiveClient {
    quizQuestion?: EntityIdRef;
    mappings?: Array<DragAndDropMappingFromLiveClient>;
    type: DragAndDropSubmittedAnswerFromLiveClientTypeEnum;
}

export type DragAndDropSubmittedAnswerFromLiveClientTypeEnum = 'drag-and-drop';

export const DragAndDropSubmittedAnswerFromLiveClientTypeEnum = {
    DragAndDrop: 'drag-and-drop' as const,
} as const;

export const DragAndDropSubmittedAnswerFromLiveClientTypeEnumValues = ['drag-and-drop'] as const;
